export default [
	{
		key: 'timestamp',
		label: 'Change Date',
		sorteable: true
	},
	{
		key: 'description',
		label: 'Feature',
		sorteable: false
	},
	{
		key: 'customerList',
		label: 'Client List',
		sorteable: false
	},
	{
		key: 'changedByUserName',
		label: 'Changed By',
		sorteable: true
	}
];
